
// Mobile > all touchstar DOM mobile Iphone
// document.addEventListener("touchstart", function(){}, true);



// When the document content has been fully loaded
document.addEventListener('DOMContentLoaded', (event) => {
  // Find all elements with 'data-click-gallery' attribute
  let galleryButtons = document.querySelectorAll('[data-click-gallery]');

  // Loop through each found element
  for(let i = 0; i < galleryButtons.length; i++) {
    let button = galleryButtons[i];

    // When a click event is triggered on the button
    button.addEventListener('click', function(event) {
      // Prevent the default action of the event (like a form submission or a link click)
      event.preventDefault();
      // Get the value of 'data-click-gallery' attribute
      let galleryId = button.getAttribute('data-click-gallery');
      // Log the value of galleryId
      console.log("Gallery ID: " + galleryId); 
      // Find the element with the 'data-gallery' attribute equals to galleryId
      let gallery = document.querySelector('[data-gallery="' + galleryId + '"]');
      
      // If the gallery element is found
      if(gallery) {
        // Log a message
        console.log("Gallery found");
        // Remove the 'dn' class from the gallery element
        gallery.classList.remove('dn');

        // Find the close button inside the gallery
        let closeButton = gallery.querySelector('.c-gal__gallery__btn-clossed');

        // If the close button is found
        if(closeButton) {
          // Remove any existing 'click' event
          closeButton.removeEventListener('click', closeGallery);
          // Assign a new click event handler
          closeButton.addEventListener('click', closeGallery.bind(null, gallery));
        }
      } else {
        // Log a message if the gallery is not found
        console.log("Gallery not found"); 
      }
    });
  }
});

// Define the close event handler
function closeGallery(gallery, event) {
  // Prevent the default action of the event
  event.preventDefault();
  // Add the 'dn' class to the gallery element
  gallery.classList.add('dn');
}

















// Toggle click
document.querySelectorAll('[data-toggle-click]').forEach(function(link) {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    var toggleId = this.getAttribute('data-toggle-click');
    var navElement = document.getElementById(toggleId);
    if (navElement) {
      navElement.style.display = (navElement.style.display === 'none') ? '' : 'none';
    }
  });
});



    // Menu mobile
    var hamburger = document.getElementById('js-hamburger');
    var html = document.getElementById('html');
    var body = document.body;
    var header = document.getElementById('header');

    // var closeDiv = document.createElement('div');
    // closeDiv.classList.add('e-close-div');
    // closeDiv.style.position = 'fixed';
    // closeDiv.style.top = 0;
    // closeDiv.style.left = 0;
    // closeDiv.style.width = '100vw';
    // closeDiv.style.height = '100vh';
    // closeDiv.style.zIndex = 0;

    // closeDiv.addEventListener('click', function() {
    //   hamburger.classList.remove('is-active');
    //   html.classList.remove('is-active-menu-mobile');
    //   header.removeChild(closeDiv);
    // });

    hamburger.addEventListener('click', function() {
      if (!this.classList.contains('is-active')) {
        this.classList.add('is-active');
        html.classList.add('is-active-menu-mobile');
        // header.appendChild(closeDiv);
      } else {
        this.classList.remove('is-active');
        html.classList.remove('is-active-menu-mobile');
        // if (header.contains(closeDiv)) {
        //   header.removeChild(closeDiv);
        // }
      }
    });



    window.addEventListener('scroll', function() {
      var headerHeight = header.offsetHeight;

      if (window.scrollY > headerHeight) {
        html.classList.add('is-scroll-active');
      } else {
        html.classList.remove('is-scroll-active');
      }
    });



    window.onload = function() {
      const switches = document.querySelectorAll('.c-switch');
      switches.forEach(function(switchElement) {
        const label = switchElement.querySelector('.c-switch__slider');
        const links = Array.from(switchElement.querySelectorAll('.c-switch__grid a'));
        label.addEventListener('click', function() {
          console.log(label);
          const inactiveLink = links.find(link => !link.classList.contains('active'));
          setTimeout(() => {
            inactiveLink.click();
          }, 220);
        });
      });
    };



    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetElement = document.querySelector(this.getAttribute('href'));
        
        if(targetElement) {
          const targetPosition = targetElement.getBoundingClientRect().top;
          let startPosition = window.pageYOffset;
          let distance = targetPosition;
          let startTime = null;

          function animation(currentTime){
            if(startTime === null) startTime = currentTime;
            let timeElapsed = currentTime - startTime;
            let run = ease(timeElapsed, startPosition, distance, 500);
            window.scrollTo(0,run);
            if(timeElapsed < 500) requestAnimationFrame(animation);
          }
          function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
          }
          requestAnimationFrame(animation);
        }
      });
    });


 // Añadir un evento click que añade la clase inmediatamente
  $('.js-popup-fancybox').on('click', function() {
    $('body').addClass('popup-active');
  });
  // onclick='$.fancybox.close();'

  // // Inicializar FancyBox para enlaces con la clase 'js-popup-fancybox'
  // $('.js-popup-fancybox').fancybox({
  //   afterClose: function(instance, slide) {
  //     // Esto se ejecutará después de que se cierre FancyBox
  //     $('body').removeClass('popup-active');
  //   }
  // });










// $('[data-fancybox]').fancybox({
//     loop : true,
//     vimeo : {
//         color : 'ebebeb',
//         background: false,
//         autoplay:true,
//         playsinline: true,
//         autopause:false,
//         byline:false,
//         title:false,
//         portrait:false
//         // muted:true,
//     }
//   });



// var $gallery = $('.gallery').flickity({
//       imagesLoaded: true,
//       percentPosition: false,
//       wrapAround: true,
//       pageDots: false,
//       cellAlign:true,
//       groupCells:1,
//       autoPlay: true,
//       contain: true,
      
//       on: {
//         ready: function() {
//           console.log('Flickity is ready');
//         },
//         change: function( index ) {
//           console.log( 'Slide changed to' + index );
//           if (this.cells[index].element.querySelector('video')){
//             this.cells[index].element.querySelector('video').play();
//           }
//         },
//         dragMove: function( event, pointer, moveVector ){
//           console.log('move');
//           var $link = $('.gallery').find('a').addClass('e-pointer-events--none');
//         },
//         dragEnd: function( event, pointer ){
//           console.log('end');
//           var $link = $('.gallery').find('a').removeClass('e-pointer-events--none');
//         },
//         staticClick: function(event, pointer, cellElement, cellIndex){
//           if (!cellElement) {
//             return;
//           }
//           var $zoomurl = $(cellElement).find('img').attr('src');
//           console.log('click');
//           $(cellElement).find('a').removeClass('e-pointer-events--none');
//         }
//       }
//     });
